import React from "react";
import { Typography } from "components/Typography";
import cx from "classnames";

import * as styles from "./PageMessage.module.scss";
import { motion } from "framer-motion";

type PageMessageProps = {
  title: string;
  subTitle?: string | React.ReactNode;
  children?: React.ReactNode;
  image?: React.ReactNode;
  className?: string;
  contentClassName?: string;
};

const PageMessage = ({
  title,
  subTitle,
  children,
  image,
  className,
  contentClassName,
}: PageMessageProps) => {
  return (
    <div className={cx(styles.container, className)}>
      {image ? image : null}
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.1 }}
      >
        <Typography className={styles.title} variant={`h3`} noSpacing>
          {title}
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.2 }}
      >
        {subTitle && typeof subTitle === "string" ? (
          <Typography className={styles.subTitle} variant={`body`} noSpacing>
            {subTitle}
          </Typography>
        ) : (
          <div className={styles.subTitle}>{subTitle}</div>
        )}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 5 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.3 }}
      >
        <div className={cx(styles.content, contentClassName)}>{children}</div>
      </motion.div>
    </div>
  );
};

export { PageMessage };
